export default __webpack_public_path__ + "static/media/announcement_icon.4939a599.svg";